import { InjectionKey } from 'vue';
import { useBuildCacheClustersProvider } from '@/views/agents/components/buildcache-clusters/buildCacheClusters.helpers';

export const IKBuildCacheClusters = Symbol('IKBuildCacheClusters') as InjectionKey<ReturnType<typeof useBuildCacheClustersProvider>>;
